export default "__VITE_ASSET__Ue6CJOOL__"